import { Divider as AnatomicDivider } from '@te-whatu-ora/anatomic'

export function Divider(props: React.ComponentProps<typeof AnatomicDivider>) {
  return (
    <div aria-hidden>
      <AnatomicDivider {...props} />
    </div>
  )
}
